export const EXPORT_SIGNED_DOCUMENT_TO_IMANAGE = 'EXPORT_SIGNED_DOCUMENT_TO_IMANAGE'
export const EXPORT_SIGNED_DOCUMENTS_TO_IMANAGE = 'EXPORT_SIGNED_DOCUMENTS_TO_IMANAGE'
export const GET_SIGNED_DOCUMENTS = 'GET_SIGNED_DOCUMENTS'
export const GET_SIGNED_DOCUMENT = 'GET_SIGNED_DOCUMENT'
